import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDishwasher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M10.65 7.78q-.1 0-.21.05-.11.04-.19.12t-.12.19-.05.22v1.59c0 1.48 1.22 2.69 2.7 2.69s2.69-1.21 2.69-2.7V8.37q0-.25-.17-.4-.16-.17-.4-.18zm.58 1.15h3.1v1.02c0 .86-.69 1.55-1.55 1.55s-1.55-.69-1.55-1.55z"
      fill="currentColor"
    />
    <path
      d="M12.78 11.5q-.24 0-.4.17-.17.16-.17.4v2.57q0 .24.17.4.16.15.4.16.24 0 .4-.16t.17-.4v-2.57q0-.24-.17-.4-.16-.16-.4-.17"
      fill="currentColor"
    />
    <path
      d="M2.16.27C1.26.27.53 1 .53 1.9v11.67c0 .9.74 1.63 1.63 1.63H8.9q.24 0 .4-.16t.17-.4q0-.12-.04-.22t-.12-.19-.19-.12-.22-.04H2.16c-.28 0-.49-.22-.49-.5V1.9c0-.28.21-.5.5-.5h10.08c.27 0 .49.22.49.5V6q0 .24.16.4.18.17.4.17.12 0 .23-.04.1-.04.18-.13.08-.07.12-.18.05-.1.05-.22V1.9c0-.9-.74-1.63-1.63-1.63z"
      fill="currentColor"
    />
    <path
      d="M1.1 4.78q-.24 0-.4.17-.16.16-.17.4 0 .11.05.22.04.1.12.18t.18.12q.11.05.22.05h12.2q.12 0 .23-.05.1-.04.18-.12t.12-.18q.05-.11.05-.22 0-.24-.17-.4-.16-.17-.4-.17z"
      fill="currentColor"
    />
    <path
      d="M3.57 7.17q-.11 0-.22.04t-.18.12q-.09.09-.13.19T3 7.74v4.5q0 .12.04.23.04.1.13.18.07.08.18.12.11.05.22.05h5.44q.12 0 .22-.05.1-.04.18-.12.09-.07.13-.18t.04-.22q0-.12-.04-.22t-.13-.19q-.07-.08-.18-.12T9 11.68H4.14V8.3h4.2q.12 0 .23-.05.1-.05.18-.12.08-.08.13-.19.04-.1.04-.21 0-.12-.04-.22-.05-.1-.13-.19t-.18-.12-.22-.04z"
      fill="currentColor"
    />
    <path
      d="M11.19 14.07q-.12 0-.22.04t-.19.12-.12.19-.04.22q0 .24.16.4.18.15.4.16h3.19q.24 0 .4-.16t.17-.4q0-.12-.04-.22t-.13-.19q-.07-.08-.18-.12t-.22-.04z"
      fill="currentColor"
    />
    <path
      d="M6.6 2.52q-.12 0-.23.05-.1.04-.18.12t-.12.19q-.05.1-.05.21 0 .24.17.4.16.17.4.17h4.25q.24 0 .4-.17.16-.16.17-.4 0-.24-.17-.4-.16-.16-.4-.17z"
      fill="currentColor"
    />
    <path
      d="M3.85 2.24q-.11 0-.22.05-.1.04-.18.12-.09.08-.13.19t-.04.21q.09.2.28.28-.2.1-.28.28 0 .12.04.22t.13.18q.07.09.18.13t.22.04c.46 0 .85-.39.85-.85s-.39-.85-.85-.85"
      fill="currentColor"
    />
    <path
      d="M3.85 2.24c-.46 0-.85.39-.85.85s.39.85.85.85q.11 0 .22-.04t.18-.13q.09-.07.13-.18t.04-.22q-.09-.19-.28-.28.2-.09.28-.28 0-.11-.04-.21-.04-.11-.13-.19t-.18-.12-.22-.05"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDishwasher;
